import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root:{
    marginTop:'10px',
    height:'100%',
    width: '100%',
  },
  title:{
    marginBottom: '27px',
    fontSize: '22px',
    fontFamily:'Inter',
    fontWeight: 600
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: "297px",
  },
  textInputWrapper: {
  },
  formLabel: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey500,
    whiteSpace:'nowrap'
  },
  textField: {
    marginTop: "8px",
    background: 'white',
    "& .MuiOutlinedInput-root": {
      border: 0,
    }
  },
  textFieldError: {
    "& .MuiOutlinedInput-root": {
      color: "red",
    }
  },
  customAddTiersButtons: {
    width: '100%',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-around',
    bottom: 30,
  }
}));

export default useStyles;
